(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("VenomConnect", [], factory);
	else if(typeof exports === 'object')
		exports["VenomConnect"] = factory();
	else
		root["VenomConnect"] = factory();
})(globalThis, function() {
return 